// запросить команлы если нет в хранилище
// найти команду
// применить контекст команды

import { useTeamStore } from "@/store/modules";

import { applyTeamContext } from "./applyTeamContext";
import { loadTeams } from "./loadTeams";

export async function initializeTeamContext({ mergePermissions, config }) {
  const teamStore = useTeamStore();

  let teams = teamStore.allTeams;

  if (!Array.isArray(teams) || teams.length === 0) {
    teams = await loadTeams(config);
  }

  const savedSlug = localStorage.getItem("selectedTeamSlug");

  const selectedTeam = resolveInitialTeam({
    teams,
    savedSlug,
  });

  await applyTeamContext({
    team: selectedTeam,
    mergePermissions,
  });

  return selectedTeam;
}

function resolveInitialTeam({ teams, savedSlug }) {
  // вынести в отдельный файл при использовании где-то кроме этого файла
  if (!Array.isArray(teams) || teams.length === 0) {
    return null;
  }

  const savedTeam = savedSlug ? teams.find((item) => item?.team?.slug === savedSlug) : null;

  if (savedTeam) {
    return savedTeam;
  }

  const ownerTeam = teams.find((item) => item?.role?.codename === "owner");

  if (ownerTeam) {
    return ownerTeam;
  }

  return teams[0];
}
